type Props = { locale: "de" | "en" };

export function LighthouseLoadingState({ locale }: Props) {
  const steps =
    locale === "de"
      ? [
          "URL wird an Google PageSpeed Insights übergeben",
          "Lighthouse-Audit läuft (Mobile, simuliertes 4G)",
          "Scores und Core Web Vitals werden berechnet",
          "Top-Verbesserungs-Hebel werden ermittelt",
        ]
      : [
          "URL submitted to Google PageSpeed Insights",
          "Lighthouse audit running (Mobile, simulated 4G)",
          "Scores and Core Web Vitals are being calculated",
          "Top improvement opportunities are being identified",
        ];
  const note =
    locale === "de"
      ? "Das Audit dauert typischerweise 20–45 Sekunden. Bitte das Fenster nicht schließen."
      : "The audit typically takes 20–45 seconds. Please do not close the window.";

  return (
    <div
      role="status"
      aria-live="polite"
      className="rounded-lg border border-rule bg-cyan-tint-2 p-8"
    >
      <div className="flex items-center gap-3">
        <span className="inline-block h-3 w-3 animate-pulse rounded-full bg-lime-deep" aria-hidden />
        <span className="font-mono text-xs uppercase tracking-[0.16em] text-ink-3">
          {locale === "de" ? "Audit läuft" : "Audit running"}
        </span>
      </div>
      <ol className="mt-5 space-y-2 text-sm text-ink-2">
        {steps.map((s, i) => (
          <li key={i} className="flex gap-3">
            <span className="font-mono text-ink-4">{String(i + 1).padStart(2, "0")}</span>
            <span>{s}</span>
          </li>
        ))}
      </ol>
      <p className="mt-5 text-xs text-ink-4">{note}</p>
    </div>
  );
}
